export default __webpack_public_path__ + "images/a5aa23c500e6ccab364f77e79aca20d8-fighting_martial_arts_small.webp";